// extracted by mini-css-extract-plugin
module.exports = {"menuItemWrapper":"_1W12N","twoColumnsWrapper":"_1Jj0U","mobileOnly":"_2jXg6"};